import { render, staticRenderFns } from "./footer.vue?vue&type=template&id=0b817c7a&scoped=true"
import script from "./footer.ts?vue&type=script&lang=ts&external"
export * from "./footer.ts?vue&type=script&lang=ts&external"
import style0 from "./footer.vue?vue&type=style&index=0&id=0b817c7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b817c7a",
  null
  
)

export default component.exports